var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.54.55c.253 0 .507.097.7.29L5.5 4.1 8.76.84c.096-.096.207-.17.326-.218.358-.145.783-.071 1.073.219.387.387.387 1.013 0 1.4L6.9 5.5l3.26 3.259c.29.29.364.716.219 1.073-.049.12-.122.23-.219.327-.096.096-.207.168-.327.216-.119.049-.246.074-.373.074-.253 0-.507-.097-.7-.29L5.5 6.9 2.24 10.16c-.193.193-.446.29-.7.29-.253 0-.507-.097-.7-.29-.387-.387-.387-1.013 0-1.4L4.1 5.5.84 2.24C.453 1.855.453 1.229.84.84c.194-.193.447-.29.7-.29z",
    transform: "translate(-1063 -445) translate(1051 253) translate(12 113) translate(0 79)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseAlt);
export default __webpack_public_path__ + "static/media/close-alt.64b8ee09ea6b003f0bef93b9a4f06629.svg";
export { ForwardRef as ReactComponent };